import { muiStyles } from 'utils/design';

export const useStyles = muiStyles((theme) => ({
  toolbar: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-end',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
}));
